<div class="row justify-content-center">
    <div class="col-11 pt-4">
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span style="font-weight: bold;">Issuer Signers</span>
            </mat-panel-title>
            <mat-panel-description>
              <span class="text-muted">{{ currentSignatoriesString }}</span>
            </mat-panel-description>
          </mat-expansion-panel-header>
            <div class="row">
              <p>
                Set your SubDoc signers for this deal from this panel.  These signers are extracted from approved KYC processes.
                <br />
                The number of Issuer signers can be a <b>minimum of one</b> and a <b>maximum of two</b>.
              </p>
            </div>
            <div class="row pt-2" *ngIf="!businessUnitEntities?.length">
              <div class="col-12" style="color: red">
                There are no issuing entities registered for this Busisness Unit, please create one first and complete its KYC.
                <br />
                Once the KYC is approved by Rondeivu, you will be able to set the Issuing Entity & SubDoc signer(s) from this form.
              </div>
            </div>
            <div class="row pt-2" *ngIf="businessUnitEntities.length > 0">
              <div class="col-8">
                <mat-form-field class="form-field" appearance="outline">
                  <mat-label>Issuing Entity</mat-label>
                  <mat-select [(ngModel)]="selectedBusinessUnitEntity" required>
                    <mat-option *ngFor="let entity of businessUnitEntities" [value]="entity">
                      {{ entity.entityName }} - with {{entity.kycSignatories.length}} Signer(s)
                    </mat-option>
                  </mat-select>
                  <mat-hint align="end">Please select the Issuing Entity.  Changing the Entities will reset your current signatories.</mat-hint>
                </mat-form-field>
                <!-- <mat-error>{{ getErrorMsg() }}</mat-error> -->
              </div>
            </div>
            <!-- ROW START -->

            <div *ngIf="businessUnitEntities?.length">
              <div class="row pt-4">
                <div class="pb-1" style="font-size: large; font-weight: bold;">Signers</div>
                <p>
                  The list of signers below are extracted from the KYC authorized signatories liked to the
                  Investing Entity selected above.  Please select each signer from the list and click <b>"Add Sub Doc Signer"</b> to add the signer to the list.
                  <br /><br />
                  <em>If you want to add a new signer, <a class="link" role="button" (click)="addNonKYCSignatory()">click here</a>.</em>
                </p>
              </div>
              <!-- ROW START -->
              <div class="row pt-1">
                <div class="col-8">
                  <mat-form-field class="form-field" appearance="outline">
                    <mat-label>Signer(s)</mat-label>
                    <mat-select id="sigs" required [(ngModel)]="selectedSignatory">
                      <mat-option *ngFor="let signatory of selectedBusinessUnitEntity?.kycSignatories" [value]="signatory">
                        {{ signatory.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-4">
                  <button mat-raised-button [disabled]="!selectedSignatory || dealSignatories.length >= syndication.numberOfIssuerSubDocSignatories"
                    (click)="addSelectedSignatory()" color="primary">Add Sub Doc Signer</button>
                </div>
              </div>

              <!-- ROW START -->
              <div class="row pt-2" *ngIf="this.dealSignatories.length > 0">
                <div class="col-12">
                  <table class="table table-striped form-table">
                    <thead>
                    <tr>
                      <th class="form-table-header" colspan="4">Current Subscription Doc Signers (Order of Signers is Important)</th>
                    </tr>
                    <tr>
                      <th class="form-table-header">Signers</th>
                      <th class="form-table-header">Email Address</th>
                      <th class="form-table-header">Signing Order</th>
                      <th class="form-table-header center">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let signatory of dealSignatories; index as i;">
                      <td>
                        {{signatory.fullName}}<br />
                        <em style="font-size: smaller; color: blue;" *ngIf="!!signatory.businessUnitEntityKycPersonId">KYC Approved Signer</em>
                        <em style="font-size: smaller; color: orange;" *ngIf="!signatory.businessUnitEntityKycPersonId">Signer not KYC Approved</em>
                      </td>
                      <td>{{signatory.email}}</td>
                      <td>{{ i + 1 }}</td>
                      <td>
                        <button mat-icon-button type="button">
                          <mat-icon color="warn"
                                    (click)="removeSignatory(signatory)"
                                    title="Remove Signer"
                          >delete
                          </mat-icon>
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="row">
                <div class="col-12 text-end">
                  <div>
                    <button mat-raised-button (click)="saveDealSignatories()" 
                      [disabled]="dealSignatories.length == 0 || dealSignatories.length > 2" color="primary">
                      Save Issuer Signer(s)
                    </button>
                  </div>
                </div>
              </div>  
            </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
